import { render, staticRenderFns } from "./CustomerOrdersPosPayment.vue?vue&type=template&id=651eb69f"
import script from "./CustomerOrdersPosPayment.vue?vue&type=script&lang=js"
export * from "./CustomerOrdersPosPayment.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrdersPosPayment.vue?vue&type=style&index=0&id=651eb69f&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports